import axios from 'axios';
import config from '../config';

const publicApi = axios.create({
  baseURL: config.apiBaseUrl,
});

export default publicApi; 